import { render, staticRenderFns } from "./inviteProxy.vue?vue&type=template&id=b580a3fc&"
import script from "./inviteProxy.vue?vue&type=script&lang=js&"
export * from "./inviteProxy.vue?vue&type=script&lang=js&"
import style0 from "./inviteProxy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports